<template>
  <v-card height="100%" v-once>
    <v-card-title primary-title>
      <div class="headline">{{labels.riskInfo}}</div>
    </v-card-title>
    <v-card-title>
      <div class="body-2">{{labels.riskAddress}}</div>
    </v-card-title>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <div v-if="fire.riskPostalCode">
              {{fire.riskAdd1}} {{fire.riskAdd2}} <span v-if="fire.riskAdd3">#{{fire.riskAdd3}}</span> {{fire.riskAdd4}}, Singapore {{fire.riskPostalCode}}
            </div>
            <div v-else>-</div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      labels: {
        riskInfo: 'Fire Risk Information',
        riskAddress: 'Risk Location',
        riskAdd1: 'Block/House No.',
        riskAdd2: 'Street Name',
        riskAdd3: 'Unit No.',
        riskAdd4: 'Building Name',
        riskPostalCode: 'Postal Code'
      }
    }
  },
  computed: {
    query() {
      return this.$store.state.agency.quotation.queryInfo
    },
    fire() {
      return this.$store.state.agency.quotation.fireForm
    }
  }
}
</script>

<style>
</style>
